import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { getLocaleContent } from '@helper/locale-content.js';
import CategoryService from '@services/category.service';
import LoadingNavigation from '@components/common/Loading/LoadingNavigation';
import Link from 'next/link';
import {safeHtml} from '@helper/sanitize-html';

export default function ListServiceProduct() {
    const { locale } = useRouter();
    const [productCategories, setProductCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedIndex, setExpandedIndex] = useState(null);

    useEffect(() => {
        const categoryService = new CategoryService();
        setLoading(true);
        categoryService
            .getProductCategoryForWeb({ locale })
            .then(response => {
                if (Array.isArray(response)) {
                    setProductCategories(response);
                } else if (response && Array.isArray(response.data)) {
                    setProductCategories(response.data);
                } else {
                    setProductCategories([]);
                }
            })
            .catch(error => {
                console.error('Error fetching service product categories:', error);
                setProductCategories([]);
            })
            .finally(() => setLoading(false));
    }, [locale]);

    return (
        <section className="specialty-section" aria-labelledby="svc-list-title">
            <h2 className="specialty-title">{getLocaleContent(locale, 'page.service.list-title')}</h2>

            {loading ? (
                <div className="specialty-loading">
                    <LoadingNavigation size="large" />
                    <p>{getLocaleContent(locale, 'page.specialty-page.loading')}</p>
                </div>
            ) : (
                <div className="specialty-grid">
                    {productCategories.map((productCategory, index) => (
                        <div
                            key={index}
                            className="specialty-list-card service-card-expandable"
                            style={{ cursor: 'pointer' }}
                            onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}>
                            <div className="specialty-list-image">
                                <img src={productCategory.picture_url} alt={productCategory.category_name} />
                            </div>
                            {expandedIndex === index ? (
                                <div className="service-overlay-content">
                                    <h3>{productCategory.category_name}</h3>
                                    <div
                                        className="service-description"
                                        style={{ maxHeight: '200px', overflow: 'auto' }}
                                        dangerouslySetInnerHTML={safeHtml(productCategory.description)}
                                    />
                                </div>
                            ) : (
                                <div className="specialty-list-info">
                                    <h3>{productCategory.category_name}</h3>
                                    <div className="service-booking-btn">
                                        <Link href="/dat-lich-kham" onClick={e => e.stopPropagation()}>
                                            {getLocaleContent(locale, 'common.booking')}
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
}
